import { push } from 'react-router-redux';
import axios from 'axios';
import { toast } from "react-toastify";
import { qpClosemodal } from '../utils/misc';

const factoringConstants = {
    FACTORING_GETALL_REQUEST: 'FACTORING_GETALL_REQUEST',
    FACTORING_GETALL_SUCCESS: 'FACTORING_GETALL_SUCCESS',
    FACTORING_GETALL_ERROR: 'FACTORING_GETALL_ERROR',
    FACTORING_PAY_POST_REQUEST: 'FACTORING_PAY_POST_REQUEST',
    FACTORING_PAY_POST_SUCCESS: 'FACTORING_PAY_POST_SUCCESS',
    FACTORING_PAY_POST_ERROR: 'FACTORING_PAY_POST_ERROR',
    FACTORING_GET_PAID_INVOICES_REQUEST: 'FACTORING_GET_PAID_INVOICES_REQUEST',
    FACTORING_GET_PAID_INVOICES_RESPONSE: 'FACTORING_GET_PAID_INVOICES_RESPONSE',
    FACTORING_POST_EXCEL_REQUEST: 'FACTORING_POST_EXCEL_REQUEST',
    FACTORING_POST_EXCEL_RESPONSE: 'FACTORING_POST_EXCEL_RESPONSE',
    FACTORING_POST_XML_REQUEST: 'FACTORING_POST_XML_REQUEST',
    FACTORING_POST_XML_RESPONSE: 'FACTORING_POST_XML_RESPONSE',
    FACTORING_POST_DOCUMENT_REQUEST: 'FACTORING_POST_DOCUMENT_REQUEST',
    FACTORING_POST_DOCUMENT_RESPONSE: 'FACTORING_POST_DOCUMENT_RESPONSE'

};

const initialState = {
    factoringInvoices: [], payTrans: [], statusList: [], deletedInvoices: [], isLoadng: false, isError: null, minaylaUrl: '', paidInvoices: [], documents: []
};

export const actionCreators = {
    getFactoringInvoices: () => async (dispatch, getState) => {

        let getInvoiceDataUrl = "api/Factoring/GetInvoicesWithDates";
        dispatch({ type: factoringConstants.FACTORING_GETALL_REQUEST, isLoading: true, isError: false })
        await axios({
            method: 'POST',
            url: getInvoiceDataUrl,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
            data: JSON.stringify({ FactoringId: 1 }),
        }).then((response) => {
            if (response.status === 200) {
                dispatch({ type: factoringConstants.FACTORING_GETALL_SUCCESS, isLoading: false, isError: false, factoringInvoices: response.data.invoices, payTrans: response.data.payTrans, statusList: response.data.statusList, deletedInvoices: response.data.deletedInvoices, minaylaUrl: response.data.minaylaUrl })
            }
        });
    },
    paySelectedFactoringInvoices: (obj) => async (dispatch, getState) => {
        let postInvoiceUrl = "api/Factoring/PayInvoices"
        console.log("stringfy", JSON.stringify(obj));
        dispatch({ type: factoringConstants.FACTORING_PAY_POST_REQUEST, isLoading: true, isError: false })
        await axios({
            method: 'POST',
            url: postInvoiceUrl,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
            data: JSON.stringify(obj),
        }).then((response) => {
            qpClosemodal("#payment-modal");
            dispatch({ type: factoringConstants.FACTORING_PAY_POST_SUCCESS, isLoading: false, isError: false })
            toast.success("Transaction successfully done.");
        });
    },
    uploadExcel: () => async (dispatch,getState) => {
        let postInvoiceUrl = "api/Factoring/ExportFactoringInvoices/"
        dispatch({ type: factoringConstants.FACTORING_POST_EXCEL_REQUEST, isLoading: true, isError: false })
        await axios({
            method: 'get',
            url: postInvoiceUrl,
            responseType :'blob',
            headers: {
                'Authorization': 'Bearer ' + getState().account.user.token,
                'Content-Disposition': "attachment;filename=report.xls",
                'Content-Type': "application/vnd.ms-excel"
            },
        }).then((response) => {
            dispatch({ type: factoringConstants.FACTORING_POST_EXCEL_RESPONSE, isLoading: false, isError: false
            })
            console.log(response);
            var headers = response.headers;
            var blob = new Blob([response.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
            );

            let fileName = response.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                    fileName);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }

        })
    },
    exportXML: (obj) => async (dispatch, getState) => {
        let postInvoiceUrl = "api/Factoring/ExportFactoringXML/"
        dispatch({ type: factoringConstants.FACTORING_POST_XML_REQUEST, isLoading: true, isError: false })
        await axios({
            method: 'post',
            url: postInvoiceUrl,
            headers: {
                'Authorization': 'Bearer ' + getState().account.user.token,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(obj)
        }).then((response) => {
            dispatch({
                type: factoringConstants.FACTORING_POST_XML_RESPONSE, isLoading: false, isError: false
            })
            console.log(response);
            
            var headers = response.headers;
            var blob = new Blob([response.data],
                { type: 'text/xml' },
            );

            let fileName = response.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'text/xml' }),
                    fileName);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/xml' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }

        })
    },
    viewInvoicesForTransactions: (id) => async (dispatch, getState) => {
        let postInvoiceUrl = "api/Factoring/paymenttransactioninvoices/" + id;
        dispatch({ type: factoringConstants.FACTORING_GET_PAID_INVOICES_REQUEST, isLoading: false, isError: false })
        await axios({
            method: 'get',
            url: postInvoiceUrl,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
        }).then((response) => {
            dispatch({ type: factoringConstants.FACTORING_GET_PAID_INVOICES_RESPONSE, isLoading: false, isError: false, paidInvoices: response.data.invoices })
           
        })
    },
    getInvoiceDocuments: (id) => async (dispatch, getState) => {
        let postInvoiceUrl = "api/Factoring/factoringinvoicedocuments/";
        dispatch({ type: factoringConstants.FACTORING_POST_DOCUMENT_REQUEST, isLoading: true, isError: false })
        await axios({
            method: 'post',
            url: postInvoiceUrl,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
            data: JSON.stringify(id)
        }).then((response) => {
            dispatch({ type: factoringConstants.FACTORING_POST_DOCUMENT_RESPONSE, isLoading: false, isError: false, documents: response.data.invoiceDocuments })

        })
    }
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}

export const reducer = (state, action) => {
    state = state || initialState;
    if (action.type === factoringConstants.FACTORING_GETALL_REQUEST) {
        return {
            isLoading: true,
        };
    }

    if (action.type === factoringConstants.FACTORING_GETALL_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            factoringInvoices: action.factoringInvoices,
            payTrans: action.payTrans,
            statusList: action.statusList,
            deletedInvoices: action.deletedInvoices,
            minaylaUrl: action.minaylaUrl,
            isError: false
        };
    }

    if (action.type === factoringConstants.FACTORING_GETALL_ERROR) {
        return {
            ...state,
            isLoading: false,
            isError : true
        };
    }


    if (action.type === factoringConstants.FACTORING_PAY_POST_REQUEST) {
        return {
            isLoading: true,
            isError: false
        };
    }

    if (action.type === factoringConstants.FACTORING_PAY_POST_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            isError: false
        };
    }

    if (action.type === factoringConstants.FACTORING_PAY_POST_ERROR) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    }
    if (action.type === factoringConstants.FACTORING_GET_PAID_INVOICES_REQUEST) {
        return {
            isLoading: true,
        };
    }

    if (action.type === factoringConstants.FACTORING_GET_PAID_INVOICES_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            paidInvoices: action.paidInvoices,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_EXCEL_REQUEST) {
        return {
            ...state,
            isLoading: true,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_EXCEL_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_XML_REQUEST) {
        return {
            ...state,
            isLoading: true,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_XML_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_DOCUMENT_REQUEST) {
        return {
            ...state,
            isLoading: true,
            isError: false
        };
    }
    if (action.type === factoringConstants.FACTORING_POST_DOCUMENT_RESPONSE) {
        return {
            ...state,
            documents: action.documents,
            isLoading: false,
            isError: false
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/FactoringStore.js